import { render, staticRenderFns } from "./LinkInfoShort.vue?vue&type=template&id=fddf901e&scoped=true&"
import script from "./LinkInfoShort.vue?vue&type=script&lang=js&"
export * from "./LinkInfoShort.vue?vue&type=script&lang=js&"
import style0 from "./LinkInfoShort.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LinkInfoShort.vue?vue&type=style&index=1&id=fddf901e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddf901e",
  null
  
)

export default component.exports